export default "__VITE_ASSET__DbimvDV3__"